import React from 'react';
import styled from 'styled-components';
import { Button } from '~/ui/buttons';

const LightButton = styled(Button)`
  background-color: #f3ecff;
  color: #9738ff;
  font-weight: unset !important;
  font-family: ralewayBold;

  &:hover {
    color: #fff;
    background-color: #9738ff;
    svg {
      path {
        fill: #fff !important;
      }
    }
  }
  &.active {
    background-color: #9845fb;
  }
  &:disabled {
    cursor: not-allowed;
    color: #000;
    svg {
      path {
        fill: grey !important;
      }
    }
  }

  &:disabled:hover {
    background-color: #a9a9a9 !important;
    color: #000 !important;
    svg {
      path {
        fill: #d4d4d4 !important;
      }
    }
  }
`;

export default LightButton;
